import type { RootState } from 'state/modules';

export const getCurrentUser = (state: RootState) => state.users.currentUser;

export const isUploading = (state: RootState) => state.users.isUploading;
